import { FC, useMemo } from 'react';
import { TabComponent } from '@marriott/mi-ui-library';
import { PrivacyRightsLoadingSkeleton } from './PrivacyRightsLoadingSkeleton';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { Dropdown } from '../../molecules/Dropdown';
import { TAB_OPTIONS } from './constant';
import { PrivacyRightsHeaderSectionProps } from './PrivacyRightsWrapper.types';

export const PrivacyRightsHeaderSection: FC<PrivacyRightsHeaderSectionProps> = ({
  subHeading,
  isAuthenticated,
  isUserPrivacyConsentDataLoading,
  header,
  handleUsNonUsResidentTabChange,
  statesLabel,
  states,
  handleStateChange,
  privacyRightsMainComponentStates,
}) => {
  const { selectedStateOrLoggedInUserStateCode, isUsStateAndBelongToCpraGroups, selectedTab, userName } =
    privacyRightsMainComponentStates;

  const statesOptions = useMemo(
    () =>
      states?.map(({ name, code }: { name: string; code: string }) => ({
        label: name,
        value: code,
      })) ?? [],
    [states]
  );

  const shouldShowStatesDropdown = isUsStateAndBelongToCpraGroups && !isAuthenticated;

  return (
    <>
      {isAuthenticated ? (
        <PrivacyRightsLoadingSkeleton isLoading={isUserPrivacyConsentDataLoading} className="userName-loader">
          <h4 className="display-name mt-4 pt-2" data-testid="legal-PrivacyRightsComponent-userName">
            {userName}
          </h4>
        </PrivacyRightsLoadingSkeleton>
      ) : (
        <>
          <h3 className="text-center">{header}</h3>
          <TabComponent
            tabList={TAB_OPTIONS}
            selectedTab={selectedTab}
            setSelectedTab={handleUsNonUsResidentTabChange}
            isSwitcherTabs={true}
            classTabsEnabled="tab-disable-border"
            customClass="tab-height"
          />
        </>
      )}

      <PrivacyRightsLoadingSkeleton isLoading={isUserPrivacyConsentDataLoading} className="privacy-subHeading-loader">
        <LegalTextWithLink
          descriptionText={subHeading}
          className="privacy-statement"
          innerChildClassName="mt-3"
          testId="legal-privacy-statement-subheading"
        />
      </PrivacyRightsLoadingSkeleton>

      {shouldShowStatesDropdown && (
        <Dropdown
          label={statesLabel}
          className="states-dropdown"
          options={statesOptions}
          name="states"
          id="states"
          value={selectedStateOrLoggedInUserStateCode}
          handleChange={handleStateChange}
        />
      )}
    </>
  );
};
